import { IconButton, styled } from '@mui/material';

export const AnimatedIconButton = styled(IconButton)(({ theme }) => ({
  transition: 'transform 0.2s ease',
  '&:active': { transform: 'scale(0.9) translateY(-2px)' },
  '&:hover': { color: theme.palette.error.main },
}));
